import { HoldingsQuote } from '@benzinga/quotes-v3-holdings-manager';
import { ParentIndex, VisualizationArgsType } from './entities';
import { Session } from '@benzinga/session';
import { QuotesV3FieldsManager } from '@benzinga/quotes-v3-fields-manager';
import { sortByString } from '@benzinga/utils';

export type HQ = keyof HoldingsQuote;

export const BzStockValues = (_args: VisualizationArgsType, _path: ParentIndex, session: Session) => {
  return (
    session
      .getManager(QuotesV3FieldsManager)
      .getNumericColumableFields()
      ?.map(args => ({ label: args.labelShort, value: args.name }))
      .sort((a, b) => sortByString(a.label, b.label)) ?? []
  );
};
